'use client';

import Link from 'next/link';
import { FC } from 'react';
import Button from '~/components/button';
import Divider from '~/components/divider';
import Socials from '~/components/socials';
import IButton from '~/data/strapi/types/shared-components/button';
import CommonData from '~/data/strapi/types/single-types/common-data';
import { YMGoal, useMetrika } from '~/providers/ya-metrica';
import emailHref from '~/utils/email-href';
import phoneHref from '~/utils/phone-href';

import styles from './styles.module.css';

interface Props {
  commonData: CommonData;
  button: IButton | null;
  headingTag?: 'h2' | 'h3';
}

const Contacts: FC<Props> = ({ commonData, button, headingTag: HeadingTag = 'h3' }) => {
  const { email, phone, socialContacts } = commonData;
  const { captureGoal } = useMetrika();

  const onPhoneClick = () => {
    captureGoal(YMGoal.NUMBER_CLICK);
  };

  const onEmailClick = () => {
    captureGoal(YMGoal.EMAIL_CLICK);
  };

  return (
    <>
      <div className={styles.contacts}>
        {phone && (
          <div className={styles.contact}>
            <HeadingTag className={styles.contactTitle}>Номер телефона:</HeadingTag>
            <Link href={phoneHref(phone)} onClick={onPhoneClick}>
              {phone}
            </Link>
          </div>
        )}
        {email && (
          <div className={styles.contact}>
            <HeadingTag className={styles.contactTitle}>Электронная почта:</HeadingTag>
            <Link href={emailHref(email)} onClick={onEmailClick}>
              {email}
            </Link>
          </div>
        )}
        {socialContacts && <Socials data={socialContacts} iconClassName={styles.social} />}
      </div>
      {button && <Button data={button} className={styles.btn} linkProps={{ scroll: false }} />}
      <Divider />
    </>
  );
};

export default Contacts;
